import create from "zustand";

export const useGlobalStore = create((set) => ({
  showShippingInfo: true,
  setShowShippingInfo: (value) => set(() => ({ showShippingInfo: value })),
}));
